import { useMediaQuery, useTheme } from '@mui/material';

/**
 * The single definition of "mobile" for the app: below the MUI `md`
 * breakpoint (900px), which is where `AppShell` swaps the sidebar for a
 * Drawer. Phones and portrait tablets are mobile; landscape tablets and up
 * are desktop. Use this instead of inlining
 * `useMediaQuery(theme.breakpoints.down('md'))` so every stacked-layout
 * decision keys off the same width (see `docs/internal/MOBILE_UI_ASSESSMENT.md` §4 —
 * changing the constant here changes it everywhere).
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
